let fingerprintLoadCalled = false;
let FingerprintJS;

/**
 * Trigger async loading of Fingerprint JavaScript agent.
 * Nothing is returned here, but if/when loading succeeds we'll
 * have a `window.fpPromise` global to use for performing fingerprinting
 * and a module-local `FingerprintJS` class.
 *
 * Also see:
 * https://dev.fingerprint.com/docs/install-the-javascript-agent
 */
function loadFingerprint() {
	if (fingerprintLoadCalled) {
		return;
	}

	fingerprintLoadCalled = true;

	// Arbitrarily delay this to avoid any possible UI jank
	// during slide transitioning, etc, caused by high main
	// JS thread CPU usage when it executes.
	setTimeout(() => {
		const publicApiKey = 'eiPlv56K34zvDqADP0Af';

		window.fpPromise = import(`https://dressing.gigsalad.com/web/v3/${publicApiKey}`)
			.then(module => {
				FingerprintJS = module;
				return FingerprintJS.load({
					endpoint: [
						'https://dressing.gigsalad.com',
						FingerprintJS.defaultEndpoint
					]
				});
			});
	}, 1000);
}

/**
 * This should be called at some point "adequately after" the
 * `loadFingerprint()` function is called, above, given the unknown
 * time it will take to load. If that loading hasn't completed then
 * the call to this function will result in the "not loaded" string
 * being assigned as the `fingerprintElement` value.
 */
function appendFingerprint(callback) {
	console.log('Append Fingerprint.');

	const fingerprintElement = this.wrapperElement.querySelector('input[name="dressing"]');

	// @see https://dev.fingerprint.com/docs/js-agent for options
	if (typeof FingerprintJS === 'undefined') {
		// Handle the case when FingerprintJS library is not available
		fingerprintElement.value = JSON.stringify({error: 'FingerprintJS library is not loaded.'});
		callback();
	} else {

		let quoteRequestId = document.querySelector('input[name="quote_request_id"][type="hidden"]').value;

		window.fpPromise
			.then(fp => fp.get({extendedResult: true, products: ['identification', 'botd'], tag: 'quoteRequest', linkedId: quoteRequestId}))
			.then(result => {
				// Append fingerprint to quoteRequest
				fingerprintElement.value = JSON.stringify(result);
				callback();
			})
			.catch(error => {
				// See errors list: https://dev.fingerprint.com/docs/js-agent#error-handling
				fingerprintElement.value = JSON.stringify({error: error.message, errorObject: error});
				callback();
			});
	}
}

export {
	loadFingerprint,
	appendFingerprint
}
